var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('iframe',{directives:[{name:"resize",rawName:"v-resize",value:({ log: true }),expression:"{ log: true }"}],attrs:{"src":_vm.getDashboard(_vm.appConfig.layout.skin),"frameborder":"0","width":"100%","allowtransparency":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }